@if (organization() && loaded()) {
  <div class="organization-container">
    <div
      data-cy="organization-logo-menu"
      class="logo-container"
      [matTooltip]="organization().company_name"
      (click)="openModal()"
      (keydown.enter)="openModal()"
      (keydown.space)="openModal()"
      tabindex="0"
    >
      @if (organization().company_logo) {
        <img
          class="logo"
          [src]="organization().company_logo"
          alt=" "
          (error)="failedToLoadImg($event)"
        />
      } @else {
        <div class="logo">
          <mat-icon>corporate_fare</mat-icon>
        </div>
      }
    </div>
    <!--  <div class="open-button" (click)="onClick()" [matTooltip]="'ORGANIZATION.SELECT_ORGANIZATION'|translate"></div>-->
    <mat-icon
      class="open-button"
      (click)="openModal()"
      (keydown.enter)="openModal()"
      (keydown.space)="openModal()"
      [matTooltip]="'ORGANIZATION.SELECT_ORGANIZATION' | translate"
      tabindex="0"
    >
      expand_more
    </mat-icon>
  </div>
}
@if (organization() === null && loaded()) {
  <div class="organization-container">
    <div
      class="logo-container"
      [matTooltip]="'ORGANIZATION.SELECT_ORGANIZATION' | translate"
      (click)="openModal()"
      (keydown.enter)="openModal()"
      (keydown.space)="openModal()"
      tabindex="0"
    >
      <!--    <div class="logo" ></div>-->
      <ng-container *ngTemplateOutlet="noOrganization"></ng-container>
    </div>
    <!--  <div class="open-button" (click)="onClick()"  [matTooltip]="'ORGANIZATION.SELECT_ORGANIZATION'|translate"></div>-->
    <mat-icon
      class="open-button"
      (click)="openModal()"
      (keydown.enter)="openModal()"
      (keydown.space)="openModal()"
      [matTooltip]="'ORGANIZATION.SELECT_ORGANIZATION' | translate"
      tabindex="0"
    >
      expand_more
    </mat-icon>
  </div>
}

<ng-template #noOrganization>
  <div class="logo" data-cy="logo-menu">
    <mat-icon>domain_disabled</mat-icon>
  </div>
</ng-template>
